import { FC } from "react";
import { Navigate, useParams } from "react-router-dom";

const LegacyGeozoneRedirect: FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Navigate to="/dashboard/geozones" replace />;
  }

  return <Navigate to={`/dashboard/geozone/${id}`} replace />;
};

export default LegacyGeozoneRedirect;
